<div class="user-management-page">
  <h2 class="page-title page-header-spacing" id="customer-heading">{{ translationService.translate('selectCustomerText') }}</h2>
  <div class="filters flex flex-row justify-center items-start sm-flex-col gap-4 search-form user-management-filters">
    <mat-form-field class="sc-search-by-name-input editable-field" subscriptSizing="dynamic">
      <mat-label>{{ translationService.translate('searchCustomerLabelText') }}</mat-label>
      <input
        matInput
        [formControl]="searchControl"
        name="name"
        placeholder="{{ translationService.translate('searchCustomerPlaceHolderText') }}"
        autocomplete="off"
      />
      <button id="search-icon-name" disabled mat-icon-button matSuffix></button>
    </mat-form-field>
    <mat-form-field class="sc-search-by-name-input editable-field" subscriptSizing="dynamic">
      <mat-label>{{ translationService.translate('searchAssignmentStatusLabelText') }}</mat-label>
      <mat-select
        placeholder="{{ translationService.translate('searchAssignmentStatusPlaceholderText') }}"
        name="status"
        id="search-assignment-status-select"
        [formControl]="assignmentStatusControl"
        (selectionChange)="handleStatusChange()"
        autocomplete="off"
      >
        <mat-option value="Yes">{{ translationService.translate('yesText') }}</mat-option>
        <mat-option value="No">{{ translationService.translate('noText') }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="sc-search-by-name-input editable-field" subscriptSizing="dynamic">
      <mat-label>{{ translationService.translate('searchTypeLabelText') }}</mat-label>
      <mat-select
        id="search-type-select"
        (selectionChange)="handleTypeChange()"
        [formControl]="customerTypeControl"
        placeholder="{{ translationService.translate('searchTypePlaceholderText') }}"
        name="type"
        autocomplete="off"
      >
        @for (type of customerTypes; track type) {
        <mat-option [value]="type">
          @if (type === 'Customer') {{{ translationService.translate('customerText') }}} @if (type === 'AssociateDealer')
          {{{ translationService.translate('associateDealerText') }}} @if (type === 'AssociateCustomer') {
          {{ translationService.translate('associateDealerCustomerText') }}
          } @if (type === 'DefaultCustomer') {{{ translationService.translate('defaultCustomerText') }}} @if (type === 'MichelinCustomer')
          {{{ translationService.translate('michelinCustomerText') }}}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div class="flex flex-row flex-1 gap-4 justify-end user-management-actions">
      <button id="reset-filters" (click)="resetFilters()" mat-flat-button color="accent" class="btn-clear" aria-label="reset filters">
        <mat-icon role="img" aria-label="restart_alt">refresh</mat-icon>{{ translationService.translate('clearFiltersText') }}
      </button>
      <button id="user-details" mat-flat-button class="btn-primary" aria-label="reset filters" (click)="checkIfCustomersAreSelected()">
        <mat-icon role="img" aria-label="back_alt">arrow_back</mat-icon>{{ translationService.translate('userDetailsText') }}
      </button>
    </div>
  </div>
  <div id="select-customer-table" class="cam-table mt-2">
    <div class="table-wrapper">
      <mic-table
        #paginatedTable
        class="table-stripped"
        [config]="tableConfig"
        [fetcher]="fetcher"
        [filtersConfig]=""
        [uniqueKey]="'customerPk'"
      >
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
        </ng-container>

        <ng-container *micCellTemplate="let item; name: 'typeCell'">
          <div class="flex flex-row gap-2">
            @if (item.customerType === 'Customer') {{{ translationService.translate('customerText') }}} @if (item.customerType ===
            'AssociateDealer') {
            {{ translationService.translate('associateDealerText') }}
            } @if (item.customerType === 'AssociateCustomer') {
            {{ translationService.translate('associateDealerCustomerText') }}
            } @if (item.customerType === 'DefaultCustomer') {
            {{ translationService.translate('defaultCustomerText') }}
            } @if (item.customerType === 'MichelinCustomer') {
            {{ translationService.translate('michelinCustomerText') }}
            }
          </div>
        </ng-container>

        <ng-container *micCellTemplate="let item; name: 'activeCell'">
          <div class="flex flex-row gap-2">
            @if (item.isAssigned === 'Yes') {
            <mic-status class="valid">{{ this.translationService.translate('yesText') }}</mic-status>
            } @if (item.isAssigned === 'No') {
            <mic-status>{{ this.translationService.translate('noText') }}</mic-status>
            }
          </div>
        </ng-container>

        <ng-container *micTableColumnSelector>
          <button mat-flat-button class="column-button">
            <mat-icon>view_column</mat-icon>
            {{ this.translationService.translate('columnsButtonText') }}
          </button>
        </ng-container>
      </mic-table>
    </div>
  </div>
</div>

<ng-template #unsavedConfirmation>{{ this.translationService.translate('unSaveChangesText') }}</ng-template>
<mic-modal class="modalC" #unsavedChangesModal></mic-modal>

<mic-modal #warningModal (result)="onModalClosed($event)"></mic-modal>

<ng-template #warningModalContent>
  {{ translationService.translate('noCustomersAssignedText') }}
</ng-template>
